// FILE: src/icons.tsx
// src/icons.tsx — Merkezi ikon sistemi
import React from "react";
import * as Ph from "@phosphor-icons/react";

/**
 * name -> Phosphor component eşlemesi (merkezi registry)
 *
 * ── #1019 — ÖLÜ YEDEK ZİNCİRLERİ KALDIRILDI (ölçülerek) ──────────────────
 * Buradaki 21 satır `Ph.A || Ph.B || Ph.C` biçimindeydi. Yedekler savunma
 * amaçlı yazılmıştı ama HİÇ ÖLÇÜLMEMİŞTİ; ölçüldüğünde iki şey birden çıktı:
 *   1. Kurulu sürümde (`@phosphor-icons/react@2.1.10`, 1512 ikon) İLK
 *      seçimlerin **51/51'i MEVCUT** → hiçbir yedek hiç çalışmıyordu.
 *   2. Ama `||` bir ÇALIŞMA-ZAMANI ifadesidir: webpack üç adı da **paketlemek
 *      zorundadır**. Ölçüldü (`main.*.js.map`, kaynak başına üretilen bayt):
 *      ana pakette **68 ikon tanımı** vardı, oysa gerçekten çizilen 49'du →
 *      19 ikon (~63 kB ham) hiç render edilmeden indiriliyordu. `yavas3g`de
 *      (51 200 B/sn) bu ~1,2 sn'dir ve her açılışta ödenir.
 * 🧭 Yedek, bir ölçümün YERİNİ TUTMAZ: ölçülmemiş bir yedek maliyet üretir,
 *    güvence üretmez. Yedeklerin karşılamak istediği gerçek risk (sürüm
 *    yükselince bir ad kaybolur ve ikon SESSİZCE değişir) artık ölçülüyor:
 *    `src/ikonKayitDefteri.test.ts` her girdinin gerçekten çözüldüğünü sınar
 *    → ad kaybolursa kapı KIRMIZI olur, ürün sessizce bozulmaz.
 */
const registry = {
  // sekmeler & temel
  grid: Ph.SquaresFour,
  // EMİR #46 FIX-2 — "4K" ikonu owner'ın BİLİNÇLİ tasarımıydı (EMİR #39'da bug
  // sanıp değiştirdik → geri alındı). KALICI KURAL: owner'a sormadan navigasyon/
  // marka ikonu DEĞİŞTİRİLMEZ.
  reels: Ph.FourK,
  checkin: Ph.MapPin,
  tagged: Ph.User,
  bookmark: Ph.BookmarkSimple,
  star: Ph.Star,
  cards: Ph.StackSimple,
  "clip-badge": Ph.Play,
  qr: Ph.QrCode,
  "external-link": Ph.ArrowSquareOut,
  plus: Ph.Plus,

  // alt gezinti
  home: Ph.House,
  search: Ph.MagnifyingGlass,

  // diğerleri
  story: Ph.Circle,
  highlight: Ph.HighlighterCircle,
  live: Ph.HandTap,
  ads: Ph.MegaphoneSimple,
  channel: Ph.Radio,
  heart: Ph.Heart,
  message: Ph.Chats,
  location: Ph.MapPin,
  menu: Ph.DotsThree,
  "menu-vertical": Ph.DotsThreeVertical,

  // aksiyonlar
  comment: Ph.ChatsCircle,
  share: Ph.PaperPlaneTilt,

  // Labubu / Gizli Kutu
  mystery: Ph.Gift,

  // harita/ayar
  settings: Ph.Gear,
  layers: Ph.MapTrifold,
  locate: Ph.GpsFix,

  globe: Ph.GlobeHemisphereWest,
  users: Ph.UsersThree,
  lock: Ph.LockSimple,
  play: Ph.Play,

  // ─── Discovery (Sosyal Keşif Katmanı) ───
  discovery: Ph.Sparkle,

  // ─── Harita premium ikonları (emoji yerine — tutarlı Phosphor ailesi) ───
  flame: Ph.Flame,
  compass: Ph.Compass,
  event: Ph.Confetti,
  crown: Ph.Crown,
  medal: Ph.Medal,
  calendar: Ph.CalendarBlank,
  basket: Ph.Basket,
  music: Ph.MusicNotes,
  soccer: Ph.SoccerBall,
  pin: Ph.MapPin,
  trophy: Ph.Trophy,
  close: Ph.X,
  // #1030 (P2-2) — `CommentsBottomSheet` çöp kutusunu elle çiziyordu.
  trash: Ph.Trash,
  target: Ph.Target,
  note: Ph.NotePencil,
  wave: Ph.HandWaving,
  female: Ph.GenderFemale,
  male: Ph.GenderMale,
};

/**
 * İkon propları — ŞEKİL KÜTÜPHANEDEN TÜRETİLDİ (`Ph.IconProps`), elle
 * yazılmadı. Gövde `size`/`color`/`weight` dışındaki her şeyi (`className`,
 * `onClick`, `style`, `aria-*`) `...rest` ile Phosphor bileşenine geçiriyor;
 * elle bir prop listesi yazsaydım 23 çağrı yerinden herhangi biri listede
 * olmayan bir prop geçtiğinde kırılırdı — ve liste sessizce eskirdi.
 *
 * 🧭 KANON: *başkasının şeklini elle kopyalama, ondan türet.*
 */
export type IkonProps = Ph.IconProps & { name?: string };

/** Kısayol ikonları `name`i kendileri veriyor — çağıran veremez. */
export type IkonKisayolProps = Omit<IkonProps, "name">;

export function Icon({ name, size = 24, color = "currentColor", weight = "regular", ...rest }: IkonProps) {
  // `name` opsiyonel (kısayollar veriyor, doğrudan `<Icon/>` kullananlar
  // vermeyebilir). Yoksa aramayı hiç yapma → aşağıdaki fallback çalışır;
  // davranış `registry[undefined]` ile birebir aynı (o da `undefined` dönerdi).
  const Cmp = name ? (registry as Record<string, unknown>)[name] : undefined;
  if (!Cmp) return <Ph.SquaresFour size={size} color={color} weight={weight} {...rest} />;
  const Bilesen = Cmp as React.ComponentType<Ph.IconProps>;
  return <Bilesen size={size} color={color} weight={weight} {...rest} />;
}

/* kısayollar */
export const GridIcon = (p: IkonKisayolProps) => <Icon name="grid" {...p} />;
export const ClipsIcon = (p: IkonKisayolProps) => <Icon name="reels" {...p} />;
export const CheckinIcon = (p: IkonKisayolProps) => <Icon name="checkin" {...p} />;
export const TaggedIcon = (p: IkonKisayolProps) => <Icon name="tagged" {...p} />;

export const CommentIcon = (p: IkonKisayolProps) => <Icon name="comment" {...p} />;
export const ShareIcon = (p: IkonKisayolProps) => <Icon name="share" {...p} />;
export const StarIcon = (p: IkonKisayolProps) => <Icon name="star" {...p} />;

export const CardsIcon = (p: IkonKisayolProps) => <Icon name="cards" {...p} />;
export const SaveIcon = ({ active = false, size = 24, color = "currentColor", ...rest }) => (
  <Ph.BookmarkSimple size={size} color={color} weight={active ? "fill" : "regular"} {...rest} />
);
export const SavedIcon = SaveIcon;

export const HomeIcon = (p: IkonKisayolProps) => <Icon name="home" {...p} />;
export const SearchIcon = (p: IkonKisayolProps) => <Icon name="search" {...p} />;
export const PlusIcon = (p: IkonKisayolProps) => <Icon name="plus" {...p} />;

export const ClipBadge = (p: IkonKisayolProps) => <Icon name="clip-badge" {...p} />;
export const QrIcon = (p: IkonKisayolProps) => <Icon name="qr" {...p} />;
export const ExternalLinkIcon = (p: IkonKisayolProps) => <Icon name="external-link" {...p} />;
export const StoryIcon = (p: IkonKisayolProps) => <Icon name="story" {...p} />;
export const HighlightIcon = (p: IkonKisayolProps) => <Icon name="highlight" {...p} />;
export const LiveIcon = (p: IkonKisayolProps) => <Icon name="live" {...p} />;
export const HandTapIcon = (p: IkonKisayolProps) => <Icon name="live" {...p} />;
export const AdsIcon = (p: IkonKisayolProps) => <Icon name="ads" {...p} />;
export const ChannelIcon = (p: IkonKisayolProps) => <Icon name="channel" {...p} />;
export const HeartIcon = (p: IkonKisayolProps) => <Icon name="heart" {...p} />;
export const MessageIcon = (p: IkonKisayolProps) => <Icon name="message" {...p} />;
export const LocationIcon = (p: IkonKisayolProps) => <Icon name="location" {...p} />;

export const KebabIcon = ({ direction = "vertical", ...rest }) => <Icon name={direction === "vertical" ? "menu-vertical" : "menu"} {...rest} />;

export const MysteryBoxIcon = (p: IkonKisayolProps) => <Icon name="mystery" {...p} />;

export const ChevronLeftIcon = (p: IkonKisayolProps) => <Ph.CaretLeft weight="regular" {...p} />;
/* #1030 (P2-2) — SAĞ chevron burada YOKTU: `PostDetailModalDesktop` bu
   yüzden kendi `<polyline>`ını yazmıştı (`strokeWidth: 2.5` → soldakinden
   kalın çizgi, aynı modalda iki farklı kalınlık). Merkeze alındı. */
export const ChevronRightIcon = (p: IkonKisayolProps) => <Ph.CaretRight weight="regular" {...p} />;
export const ChevronDownIcon = (p: IkonKisayolProps) => <Ph.CaretDown weight="regular" {...p} />;
export const VerifiedBadgeIcon = (p: IkonKisayolProps) => <Ph.SealCheck weight="regular" {...p} />;

export const LayersIcon = (p: IkonKisayolProps) => <Icon name="layers" {...p} />;
export const SettingsIcon = (p: IkonKisayolProps) => <Icon name="settings" {...p} />;
export const LocateIcon = (p: IkonKisayolProps) => <Icon name="locate" {...p} />;

// Harita premium ikon kısayolları (emoji yerine)
export const FlameIcon = (p: IkonKisayolProps) => <Icon name="flame" {...p} />;
export const CompassIcon = (p: IkonKisayolProps) => <Icon name="compass" {...p} />;
export const EventIcon = (p: IkonKisayolProps) => <Icon name="event" {...p} />;
export const CrownIcon = (p: IkonKisayolProps) => <Icon name="crown" {...p} />;
export const MedalIcon = (p: IkonKisayolProps) => <Icon name="medal" {...p} />;
export const CalendarIcon = (p: IkonKisayolProps) => <Icon name="calendar" {...p} />;
export const BasketIcon = (p: IkonKisayolProps) => <Icon name="basket" {...p} />;
export const MusicIcon = (p: IkonKisayolProps) => <Icon name="music" {...p} />;
export const SoccerIcon = (p: IkonKisayolProps) => <Icon name="soccer" {...p} />;
export const PinIcon = (p: IkonKisayolProps) => <Icon name="pin" {...p} />;
export const TrophyIcon = (p: IkonKisayolProps) => <Icon name="trophy" {...p} />;
export const CloseIcon = (p: IkonKisayolProps) => <Icon name="close" {...p} />;
export const TrashIcon = (p: IkonKisayolProps) => <Icon name="trash" {...p} />;
export const TargetIcon = (p: IkonKisayolProps) => <Icon name="target" {...p} />;
export const NoteIcon = (p: IkonKisayolProps) => <Icon name="note" {...p} />;
export const WaveIcon = (p: IkonKisayolProps) => <Icon name="wave" {...p} />;
export const FemaleIcon = (p: IkonKisayolProps) => <Icon name="female" {...p} />;
export const MaleIcon = (p: IkonKisayolProps) => <Icon name="male" {...p} />;

// ✅ opsiyonel kısayollar
export const GlobeIcon = (p: IkonKisayolProps) => <Icon name="globe" {...p} />;
// ─── Discovery ───
export const DiscoveryIcon = (p: IkonKisayolProps) => <Icon name="discovery" {...p} />;
export const UsersIcon = (p: IkonKisayolProps) => <Icon name="users" {...p} />;
export const LockIcon = (p: IkonKisayolProps) => <Icon name="lock" {...p} />;
export const PlayIcon = (p: IkonKisayolProps) => <Icon name="play" {...p} />;

